import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const PricingFAQ = () => <FAQSectionI18n translationPrefix="pricing" />;
export default PricingFAQ;
